import React from "react";
import UserAccessTable from "user_access/UserAccessTable";
import UserNewForm from "user_access/UserNewForm";
import LeftIndent from "utils/LeftIndent";
import Form from "react-bootstrap/Form";
import { truncate } from "lodash";

class UserAccess extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      users: [],
      unaffiliated_users: []
    };
  }

  
  componentDidMount() {
    const users = this.props.users
    const unaffiliated_users = this.props.unaffiliated_users
    const userInfo = Object.values(users)
    const unaffiliated_userInfo = Object.values(unaffiliated_users)
    this.setState({
      users: userInfo.sort((a, b) => a.name.localeCompare(b.name)),
      unaffiliated_users: unaffiliated_userInfo.sort((a, b) => a.name.localeCompare(b.name))
    });
    $(".collapser").on("click", function () {
      $(this).next(".collapse").collapse("toggle");
      var icon = $(this).find(".fas");
      if (icon.hasClass("fa-sort-up")) {
        icon.removeClass("fa-sort-up").addClass("fa-sort-down");
      } else {
        icon.removeClass("fa-sort-down").addClass("fa-sort-up");
      }
    });
  }

  deleteUser(user) {
    $.ajax({
      url: "/datapulse/users/" + user.id,
      type: "delete",
    });
  }

  removeUser(user, org_id) {
    console.log(user, org_id)
    $.ajax({
			type: "POST",
			url: "/datapulse/organization/remove-user/",
			data: {
				organization_id: org_id,
        user_id: user.id
			},
		});
  }


  searchUsers(e) {
    let searchString = e.target.value.toLowerCase();
    let newUsers = [];
    this.props.users_array.forEach((u) => {
      if ((u.first_name + " " + u.last_name).toLowerCase().includes(searchString) || u.email.toLowerCase().includes(searchString)) {
        newUsers.push(u);
      }
    });

    this.setState({
      users: newUsers,
    });
  }

  render() {
    return (
      <>
        <div className="standard-page-padding">
          <h1>User Access</h1>
          <div className="d-flex justify-content-space-between flex-wrap gap-24">
            <div className="d-flex align-items-center gap-24">
              <p style={{fontSize: "20px"}}><b>Search:</b></p>
              <input type="text" className="tableSearch lite-input" placeholder="" onChange={(e) => {this.searchUsers(e);}} />
            </div>
            <UserNewForm clients={this.props.clients} createUserPath={this.props.createUserPath} pathMethod={this.props.pathMethod} />
          </div>
          <UserAccessTable org_id={this.props.org_id} current_user_is_god = {this.props.current_user_is_god} permissions={this.props.permissions} users={this.state.users.filter((u) => u.role == "client")} deleteUser={this.deleteUser}  removeUser={this.removeUser} tableName="Clients" />
          <UserAccessTable org_id={this.props.org_id} current_user_is_god = {this.props.current_user_is_god} permissions={this.props.permissions} users={this.state.users.filter((u) => u.role == "employee")} deleteUser={this.deleteUser} removeUser={this.removeUser} tableName="Employees - Restricted Access" />
          <UserAccessTable org_id={this.props.org_id} current_user_is_god = {this.props.current_user_is_god} permissions={this.props.permissions} users={this.state.users.filter((u) => u.role == "specialist")} deleteUser={this.deleteUser} removeUser={this.removeUser} tableName="Employees - Standard Access" />
          <UserAccessTable org_id={this.props.org_id} current_user_is_god = {this.props.current_user_is_god} permissions={this.props.permissions} users={this.state.users.filter((u) => u.role == "manager")} deleteUser={this.deleteUser} removeUser={this.removeUser} tableName="Employees - Full Access" />
          <UserAccessTable org_id={this.props.org_id} current_user_is_god = {this.props.current_user_is_god} permissions={this.props.permissions} users={this.state.users.filter((u) => u.role == "admin")} deleteUser={this.deleteUser} removeUser={this.removeUser} tableName="Employees - Admin Access" />
          {this.props.current_user_is_god &&
          <UserAccessTable unaffiliated={true} org_id={this.props.org_id} current_user_is_god = {this.props.current_user_is_god} permissions={this.props.permissions} users={this.state.unaffiliated_users} deleteUser={this.deleteUser} removeUser={this.removeUser} tableName="Users - Unaffiliated" />}
        </div>
      </>
    );
  }
}

export default UserAccess;
